import React from 'react';
import { ButtonSubtle } from '@jimdo/ui';
import './hint.scss';

interface Props {
  html: string;
  className: string;
  onClick?: () => void;
  ctaText?: string;
  children?: React.ReactChild;
}

const Hint: React.SFC<Props> = (props: Props) => {
  const { html, onClick, ctaText } = props;

  // tslint:disable react-no-dangerous-html
  return (
    <div className={props.className}>
      <span dangerouslySetInnerHTML={{ __html: html }} />
      {props.children}
      {ctaText && onClick ? (
        <ButtonSubtle className="hint-component__cta" onClick={onClick}>
          {ctaText}
        </ButtonSubtle>
      ) : null}
    </div>
  );
  // tslint:enable react-no-dangerous-html
};

export default Hint;
